import React from 'react';
import {renderLines} from '../../helpers';

export default (props) => {
    return <div>
        <div className="syntax__edit-pane">
        {renderLines(14, '800px')}
        {renderTheme(props.styles)}
        </div>
    </div>;
};

const renderTheme = (styles) => {
    return <div>
        <span style={styles.comment}>&lt;!--<br />
        &nbsp;Keyboard Shortcuts:<br />
        &nbsp;<br />
        &nbsp;[up/down] &nbsp;&nbsp;&nbsp;- Switch Theme.<br />
        &nbsp;[left/right] - Switch Language.<br />
        &nbsp;[n/c/l] &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Switch Theme Type.<br />
        &nbsp;--&gt;</span><br />
        <span style={styles.comment}>&lt;!DOCTYPE html&gt;</span><br />
        &lt;<span style={styles.keyword}>html</span> <span style={styles.function}>lang</span>=<span style={styles.string}>"en"</span>&gt;<br />
        &lt;<span style={styles.keyword}>head</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>meta</span> <span style={styles.function}>charset</span>=<span style={styles.string}>"UTF-8"</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>meta</span> <span style={styles.function}>name</span>=<span style={styles.string}>"viewport"</span> <span style={styles.function}>content</span>=<span style={styles.string}>"width=device-width, initial-scale=1.0"</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>meta</span> <span style={styles.function}>http-equiv</span>=<span style={styles.string}>"X-UA-Compatible"</span> <span style={styles.function}>content</span>=<span style={styles.string}>"ie=edge"</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>title</span>&gt;Rainglow&lt;/<span style={styles.keyword}>title</span>&gt;<br />
        &lt;/<span style={styles.keyword}>head</span>&gt;<br />
        &lt;<span style={styles.keyword}>body</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>h1</span>&gt;Hello&lt;/<span style={styles.keyword}>h1</span>&gt;<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span style={styles.keyword}>p</span>&gt;Thanks for using Rainglow!&lt;/<span style={styles.keyword}>p</span>&gt;<br />
        &lt;/<span style={styles.keyword}>body</span>&gt;<br />
        &lt;/<span style={styles.keyword}>html</span>&gt;
    </div>;
};


// WEBPACK FOOTER //
// ./src/components/syntax/HTML.js